"use client";

import { NextIntlClientProvider } from "next-intl";

import { TrackedErrorPage } from "@/components/tracked-error-page";
import enMessages from "@/messages/en.json";

export default function SiteRootError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <NextIntlClientProvider locale="en" messages={enMessages}>
      <TrackedErrorPage error={error} reset={reset} />
    </NextIntlClientProvider>
  );
}
